import React from 'react'

export const COLUMNS = [
  { name: 'name', displayName: 'Name', group: 'base', dataType: 'string', align: 'left', sortable: true, filterable: false, hidden: false, exclude: false, width: 180 },
  { name: 'email', displayName: 'Email', accessorKey: 'email', group: 'base', dataType: 'string', align: 'left', sortable: true, filterable: false, hidden: false, exclude: false, width: 220, formatString: 'title' },
  { name: 'households', displayName: 'Households', accessorKey: 'households', group: 'base', dataType: 'string', align: 'left', sortable: true, filterable: false, hidden: false, exclude: false, width: 240 },
  { name: 'lastLoginTimestamp', displayName: 'Last Login', accessorKey: 'lastLoginTimestamp', group: 'base', dataType: 'date', align: 'left', sortable: true, filterable: false, hidden: false, exclude: false, width: 180, formatString: 'localDateTime' },
  { name: 'userAgent', displayName: 'User Agent', accessorKey: 'userAgent', group: 'base', dataType: 'string', align: 'left', sortable: false, filterable: false, hidden: false, exclude: false, width: 320 }
]

const nameCellStyle = {
  fontSize: '.75rem',
  fontWeight: 700,
  color: '#2B3148'
}

const dateCellStyle = {
  fontSize: '.75rem',
  color: '#4B5563'
}

const secondaryCellStyle = {
  fontSize: '.75rem',
  color: '#6B7280'
}

function formatName (row) {
  return [row?.firstName, row?.lastName].filter(Boolean).join(' ').trim()
}

export function buildTanstackColumns (columns, formatter) {
  return columns
    .filter(c => !c.hidden && !c.exclude)
    .map(col => {
      const formatString = col.formatString || col.formatType || null
      const def = {
        id: col.name,
        header: col.displayName,
        align: col.align || 'left',
        enableSorting: col.sortable !== false,
        size: col.width || 150
      }

      if (col.name === 'name') {
        def.accessorFn = (row) => formatName(row)
        def.cell = ({ row }) => {
          const text = formatName(row.original)
          if (!text) return null
          return <span style={nameCellStyle}>{text}</span>
        }
        return def
      }

      def.accessorKey = col.accessorKey ?? col.name

      if (col.name === 'lastLoginTimestamp') {
        def.cell = ({ getValue }) => {
          const value = getValue()
          const text = value == null ? 'Never logged in' : formatter(value, formatString)
          return <span style={dateCellStyle}>{text}</span>
        }
        return def
      }

      if (col.name === 'email' || col.name === 'households') {
        def.cell = ({ getValue }) => {
          const value = getValue()
          if (value == null) return null
          const text = formatString ? formatter(value, formatString) : String(value)
          return <span style={secondaryCellStyle}>{text}</span>
        }
        return def
      }

      if (col.name === 'userAgent') {
        def.cell = ({ getValue }) => {
          const value = getValue()
          if (value == null) return null
          return <span style={secondaryCellStyle}>{value}</span>
        }
        return def
      }

      if (formatString) {
        def.cell = ({ getValue }) => formatter(getValue(), formatString)
      }

      return def
    })
}
